<template>
    <!--分页组件-->
    <div class="pagination-con" v-if="config.total">
        <div class="pagination-info">共{{config.pageTotal}}页/{{config.total}}条</div>
        <div class="pagination">
            <!--上一页-->
            <button class="prev" @click="prePage" v-show="currentPage > 1">上一页</button>
            <!--总页数小于8的-->
            <template v-if="pageTotal <= showPageNo">
                <button v-for="i in pageTotal" @click="changeCurrentPage(i)" :class="{active:i === currentPage}" :key="i">{{i}}</button>
            </template>
            <template v-else-if="currentPage < 4">
                <button v-for="i in 6" @click="changeCurrentPage(i)" :class="{active:i === currentPage}" :key="i">{{i}}</button>
                <button :disabled="true">···</button>
                <button @click="changeCurrentPage(pageTotal)">{{pageTotal}}</button>
            </template>
            <template v-else-if="currentPage > pageTotal - 4">
                <button @click="changeCurrentPage(1)">1</button>
                <button :disabled="true">···</button>
                <button v-for="i in 6" @click="changeCurrentPage(i + (pageTotal - 6))" :class="{active:(i + (pageTotal - 6)) === currentPage}" :key="i">{{i + (pageTotal - 6)}}</button>
            </template>
            <template v-else>
                <button @click="changeCurrentPage(1)">1</button>
                <button :disabled="true">···</button>
                <button @click="changeCurrentPage(currentPage - 2)">{{currentPage - 2}}</button>
                <button @click="changeCurrentPage(currentPage - 1)">{{currentPage - 1}}</button>
                <button class="active">{{currentPage}}</button>
                <button @click="changeCurrentPage(currentPage + 1)">{{currentPage + 1}}</button>
                <button @click="changeCurrentPage(currentPage + 2)">{{currentPage + 2}}</button>
                <button :disabled="true">···</button>
                <button @click="changeCurrentPage(pageTotal)">{{pageTotal}}</button>
            </template>
            <!--下一页-->
            <button class="next" @click="nextPage" v-show="currentPage < pageTotal">下一页</button>
        </div>
    </div>


</template>

<script>
  export default {
    name: "Pagination",
    props: {
      // 分页配置
      config: {
        type: Object, require: true, default() {
          return {
            pageSize: 10,     //一页的数据条数
            pageNo: 0,        //当前页的索引
            total: 0,         //总的数据条数
            pageTotal: 0      //总的页数
          }
        }
      }
    },
    data() {
      return {
        //默认显示
        showPageNo:5,
        currentPage: this.config.pageNo || 0
      }
    },
    methods: {
      prePage(){
        this.currentPage -= 1
        this.$emit('changeCurrentPage',this.currentPage)
      },
      nextPage(){
        this.currentPage += 1
        this.$emit('changeCurrentPage',this.currentPage)
      },
      changeCurrentPage(i){
        this.currentPage = i
        this.$emit('changeCurrentPage',this.currentPage)
      }
    },
    computed: {
      //计算总页数，如果传了pageTotal,直接取pageTotal的值，如果传了total，那么根据pageSize去计算
      pageTotal(){
        const config = this.config
        if(config.pageTotal){
          return config.pageTotal
        }else {
          if(config.pageSize && config.total){
            return Math.ceil(config.total/config.pageSize)
          }else {
            return 0
          }
        }
      }
    },
    watch: {
      config(newValue) {
        this.currentPage = newValue.pageNo || 0
      }
    }

  }
</script>

<style lang="less" scoped>
.pagination-con {
    float: right;
    .pagination-info {
        font-size: 14px;
        color: #282b2c;
        float: left;
        margin: 20px 0;
        margin-right: 20px;
        line-height: 38px;
    }
}
.pagination {
    display: inline-block;
    padding-left: 0;
    margin: 20px 0;
    border-radius: 4px;
    button{
        float: left;
        margin: 0 5px;
        width: 38px;
        height: 38px;
        line-height: 38px;
        background: #fff;
        border: 1px solid #ebebeb;
        color: #bdbdbd;
        font-size: 14px;
        &[disabled]{
            color: #bdbdbd;
            background-color: transparent;
            border: none;
            cursor: not-allowed;
        }
        &.active{
            float: left;
            margin: 0 5px;
            width: 38px;
            height: 38px;
            line-height: 38px;
            background: #006ab9;
            color: #fff;
            font-size: 14px;
            border: 1px solid #006ab9;
        }
        &.prev, &.next {
            width: auto;
            padding: 0 13px;
            background: #006ab9;
            color: #fff;
        }
    }
}
</style>
